export default "/HowToPlay.png";